"use client";

import GailConversationPanel from "../GailConversationPanel";
import {ArtifactPanelProvider} from "@/contexts/chat/ArtifactPanelContext";
import {useGailDock} from "@/contexts/chat/GailDockContext";

export default function GailDockPanel() {
   const {conversationId, setDockConversation, closeDock, startNewChat} = useGailDock();
   return (
      <ArtifactPanelProvider key={conversationId ?? "new-chat"} coversConversation>
         <GailConversationPanel
            conversationId={conversationId}
            onSelectConversation={setDockConversation}
            onClose={closeDock}
            onNewChat={startNewChat}
            overlayArtifacts
         />
      </ArtifactPanelProvider>
   );
}
